import React from 'react';
import {
  DialogBackdrop,
  DialogBody,
  DialogContent,
  DialogRoot,
} from '@/components/ui/dialog';
import { QRCodeCanvas } from 'qrcode.react';
import { useSelector } from 'react-redux';
import { IRedux } from '@/_store/types';

export default function QRModal({
  open,
  onOpenChange,
}: {
  open: boolean;
  onOpenChange: (e: boolean) => void;
}) {
  const { user } = useSelector((state: IRedux) => state.auth);

  return (
    <DialogRoot
      lazyMount
      open={open}
      placement={'center'}
      onOpenChange={(e) => onOpenChange(e.open)}
    >
      <DialogBackdrop />
      <DialogContent mx={'10'} w={'fit'}>
        <DialogBody
          display={'flex'}
          justifyContent={'center'}
          alignItems={'center'}
          mx={'auto'}
          m={0}
          bg='#fff'
          p={2}
        >
          <QRCodeCanvas
            value={user?.phone?.replace('+', '') || ''}
            size={290}
            bgColor={'#ffffff'}
            fgColor={'#000000'}
            level={'M'}
          />
        </DialogBody>
      </DialogContent>
    </DialogRoot>
  );
}
